import { type WrappedInsightShiftsWorkedAttributes } from "@clipboard-health/contract-worker-app-bff";
import { Card, Image, Text } from "@clipboard-health/ui-components";
import { CardContent } from "@mui/material";
import calendarImagePath from "@src/appV2/lib/assets/images/cbh-wrapped/calendar.png";

import { InsightContentWrapper } from "../InsightContentWrapper";
import { ShiftsWorkedRow } from "./ShiftsWorkedRow";

// eslint-disable-next-line no-restricted-syntax
const CARD_BACKGROUND_COLOR = "#FFC1C6BF";
// eslint-disable-next-line no-restricted-syntax
const CARD_BORDER_COLOR = "#FFCED2BF";

interface ShiftsWorkedContentProps {
  attributes: WrappedInsightShiftsWorkedAttributes;
}

export function ShiftsWorkedContent(props: ShiftsWorkedContentProps) {
  const { attributes } = props;

  return (
    <InsightContentWrapper>
      <Text
        variant="h1"
        sx={(theme) => ({
          fontSize: "4.75rem",
          color: theme.palette.text.invertPrimary,
          marginTop: 5,
        })}
      >
        {attributes.amShiftsCount + attributes.pmShiftsCount + attributes.nocShiftsCount}
      </Text>

      <Text
        variant="h3"
        sx={(theme) => ({ color: theme.palette.text.invertPrimary, paddingBottom: 4 })}
      >
        Shifts worked!
      </Text>

      <Card
        sx={(theme) => ({
          backgroundColor: CARD_BACKGROUND_COLOR,
          borderWidth: theme.borderWidth.thick,
          borderColor: CARD_BORDER_COLOR,
          borderStyle: "solid",
          marginRight: theme.spacing(10),
          position: "relative",
          zIndex: 1,
          flex: 1,
        })}
      >
        <CardContent>
          <ShiftsWorkedRow label="AM shifts:" value={attributes.amShiftsCount} />

          <ShiftsWorkedRow label="PM shifts:" value={attributes.pmShiftsCount} />

          <ShiftsWorkedRow label="NOC shifts:" value={attributes.nocShiftsCount} />
        </CardContent>
      </Card>

      <Image
        src={calendarImagePath}
        alt="Shifts worked"
        sx={{ position: "absolute", bottom: 0, right: 0 }}
      />
    </InsightContentWrapper>
  );
}
